<template>
  <header class="sticky top-0 z-50 bg-white">
    <Container class="flex justify-between items-center h-header">
      <LogoPavillonHome class="text-black hover:text-stone-500" />
      <PageMenuLanguageSwitch :is-high-contrast="false" class="pr-2" />
    </Container>
  </header>
</template>
